import { render, staticRenderFns } from "./updateAttrInfoDialog.vue?vue&type=template&id=77baf5de&"
import script from "./updateAttrInfoDialog.vue?vue&type=script&lang=js&"
export * from "./updateAttrInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports